import { format } from 'date-fns';
import VersionControlActions from '../components/detail/VersionControlActions/VersionControlActions';

import styles from '../components/detail/VersionControlDialgue/VersionControlDialgue.module.scss';

const getColumnClassName = (params) => {
    let className = styles['version-data-table-item'];
    if(params && params.row && params.row.rowIndex === 0) {
        className = styles['version-data-table-item-current'];
    }
    return className;
}

export function getVersionColumns (props) {
    const columns = [
        {
            field: 'id',
            hide: true,
            hideFromColumnsSelector: true,
            cellClassName: getColumnClassName,
            sortable: false,
            renderHeader: () => null
        },
        {
            field: 'versionNumberText',
            type: 'string',
            hideFromColumnsSelector: true,
            cellClassName: getColumnClassName,
            sortable: false,
            flex: 0.5,
            renderHeader: () => null
        },
        {
            field: 'versionDateTimeText',
            type: 'string',
            hideFromColumnsSelector: true,
            cellClassName: getColumnClassName,
            sortable: false,
            flex: 1,
            renderHeader: () => null
        },
        {
            field: 'actions',
            hideFromColumnsSelector: true,
            cellClassName: getColumnClassName,
            sortable: false,
            renderHeader: () => null,
            flex: 0.9,
            align: 'right',
            renderCell: (params) => (
                <VersionControlActions
                    id={params.row.objectID}
                    rowIndex={params.row.rowIndex}
                    versionData={params.row.versionData}
                 />
            )
        }
    ];
    
    return columns;
}

export function getVersionRows (data) {

    const rows = [];
        
    if(data !== null) {

        data.forEach((row, i) => {

            const versionNumberText = `Version ${row.versionNumber}`;
            const versionDateFormatted = format(new Date(row.versionDateTime), "MMMM do, yyyy");
            const versionDateTimeText = `Changed ${versionDateFormatted}`;

            rows[i] = {
                id: row.versionId,
                versionDateTimeText: versionDateTimeText,
                versionNumberText: versionNumberText,
                objectID: row.objectId,
                versionData: row.versionData,
                rowIndex: i
            }

        });      

    }


    return rows;

}